import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { IdleUser } from './IdleUser';

export const SessionTimeout = () => {
  const onLogout = () => {
    window.location = `${config('IDENTITY_API_URL')}/logout`;
  };

  const handleLogout = async () => {
    onLogout();
  };

  const events = {
    onSignout: () => {
      if (config('APP_ENV') !== 'local') {
        handleLogout();
      }
    },
  };

  return (
    <React.Fragment>
      <IdleUser events={events} />
    </React.Fragment>
  );
};
